import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import Task from '../Components/Task'
import isSameDay from 'date-fns/is_same_day'
import { CHANGE_TASK_ID, TOOLTIP_STATES } from '../constants';
class TaskContainer extends PureComponent {

    isShowMarker = () => {
        const { tooltip, id, draggable, inactive, date, startDate, resizeLeft } = this.props
        return !inactive && draggable && (isSameDay(date, startDate) || resizeLeft) && CHANGE_TASK_ID === id && (tooltip === TOOLTIP_STATES.MOVE || tooltip === TOOLTIP_STATES.RESIZE)
    }

    render() {
        return <Task {...this.props} showMarker={this.isShowMarker()} />
    }
}

const mapStateToProps = (state) => {
    return {
        tooltip: state.main.tooltipType
    }
}

export default connect(mapStateToProps)(TaskContainer)